<template>
  <q-layout
    view="hHh Lpr lff"
    container
    :class="['layout-menu', {'layout-menu--mini': isMenuMini}, 'full-height']"
  >
    <q-drawer
      v-model="drawer"
      behavior="desktop"
    >
      <template v-slot:mini>
        <q-scroll-area class="fit mini-slot">
          <div
            v-for="m in menu"
            :key="m.title"
            class="layout-menu-item"
            :class="{active: isActive(m.path) }"
            @click="menuHandler(m)"
          >
            <div
              class="layout-menu-item-icon"
              v-html="m.icon"
            />
          </div>
        </q-scroll-area>
      </template>

      <template v-slot:default>
        <q-scroll-area class="fit">
          <div
            v-for="m in menu"
            :key="m.title"
            class="layout-menu-item"
            :class="{active: isActive(m.path) }"
            @click="menuHandler(m)"
          >
            <div
              class="layout-menu-item-icon"
              v-html="m.icon"
            />
            <div class="layout-menu-item-title">
              {{ m.title }}
            </div>
          </div>
        </q-scroll-area>
      </template>
    </q-drawer>
  </q-layout>
</template>

<script>
/**
 * Десктопное боковое меню
 * @module Layout/Component/Menu
 * @requires Layout
 * @requires vuex
 * @vue-prop {String} currentPage - текущая страница
 * */


export default {
  name: 'VueLayoutMenu',
  props: {
    menu: Array,
    isMenuMini: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    drawer: true,
    drawerWidth: null,
    drawerMiniWidth: null
  }),
  computed: {
    currentPage: {
      get() {
        return this.$route.fullPath
      },
      set(newPath) {
        return newPath
      }
    }
  },
  methods: {
    menuHandler(m) {
      this.currentPage = m.path;
      this.$router.push(m.path)
    },
    /**
     * Стравнивает значение пункта меню с текущей страницей
     * @function
     * @param {String} page - пункт меню
     * */
    isActive(page) {
      return page === this.currentPage
    }
  }
}
</script>
